import { render } from "./BatchEditor.vue?vue&type=template&id=65bd6918"
import script from "./BatchEditor.vue?vue&type=script&lang=js"
export * from "./BatchEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__